import { defineMessages } from 'react-intl';

export default defineMessages({
  closeDrawerButton: {
    id: 'ariaLabel.closeDrawerButton',
    defaultMessage: 'Close drawer button',
  },
});
